import { pathOr } from 'rambda';
import { contramap } from 'fp-ts/Ord';
import * as S from 'fp-ts/string';
import { pipe } from 'fp-ts/function';

export const byLabel = pipe(S.Ord, contramap(pathOr('', 'label')));
